<div class="container">
  <app-header-actions
    [headerTitle]="'REFERENCES.TITLE'"
    [headerIcon]="faBookmark"
    [config]="headerConfig"
    [initialFilters]="currentFilters"
    [count]="totalItems + ' ' + ('REFERENCES.TITLE' | translate)"
    [showCount]="true"
    (filtersChanged)="onFiltersChanged($event)"
    (searchCleared)="onSearchCleared()"
    (tagFilterCleared)="onTagFilterCleared()"
    (allFiltersCleared)="onAllFiltersCleared()">
  </app-header-actions>

  <app-item-list
    [items]="referencesAsListItems"
    [loading]="loading"
    [config]="listConfig"
    [hasActiveFilters]="!!currentFilters.searchTerm || !!currentFilters.selectedTag"
    (itemClick)="onReferenceClick($event)"
    (actionClick)="onActionClick($event)"
    (tagClick)="tagManager.openTagDescription($event)">
  </app-item-list>

  <app-pagination
    [currentPage]="currentPage"
    [totalPages]="totalPages"
    [totalItems]="totalItems"
    [pageSize]="pageSize"
    (pageChange)="onPageChange($event)">
  </app-pagination>

  <app-tag-manager #tagManager entityType="references" [entityName]="'REFERENCES.TITLE' | translate"
    (tagChanged)="onTagChanged()">
  </app-tag-manager>
</div>
